// One instance per editor: versions belong to the loaded draft, never a global cache.
export function managementDraft() {
  let resource = null;
  let version = null;
  let pending = null;
  return {
    loaded(id, data) { resource = id; version = Number.isSafeInteger(data.version) ? data.version : null; pending = null; },
    request(id, data) {
      if (id !== resource) throw new Error('Load the settings before saving.');
      const payload = version === null ? data : { ...data, expected_version: version };
      const body = JSON.stringify(payload);
      if (!pending || pending.body !== body) pending = { body, key: window.crypto.randomUUID() };
      return { method: 'PUT', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': pending.key }, body };
    },
    saved(id, data) { if (id === resource) { version = Number.isSafeInteger(data.version) ? data.version : version; pending = null; } },
  };
}

export async function readManagement(fetcher, kind, id, legacyPath) {
  const base = process.env.REACT_APP_API_BASE_URL;
  const response = await fetcher(`${base}management/${kind}/${id}`);
  // The additive Portal release can also run against a deployment before migration/activation.
  if ([404, 503].includes(response?.status)) return fetcher(`${base}${legacyPath}/${id}`);
  return response;
}

export async function managementSaved(response, draft, id, t) {
  if (!response?.ok) {
    const conflict = response?.status === 409;
    const message = t(conflict ? 'mcp_settings_conflict' : 'mcp_settings_save_failed');
    window.dispatchEvent(new CustomEvent('api-error', { detail: { status: response?.status || 0, message } }));
    throw new Error(message);
  }
  const result = await response.json();
  draft.saved(id, result);
  return result;
}
